import { render, staticRenderFns } from "./RowComentario.vue?vue&type=template&id=0b99e59d&scoped=true&lang=pug&"
import script from "./RowComentario.vue?vue&type=script&lang=js&"
export * from "./RowComentario.vue?vue&type=script&lang=js&"
import style0 from "./RowComentario.vue?vue&type=style&index=0&id=0b99e59d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99e59d",
  null
  
)

export default component.exports